window.moment = require('moment')
require('moment/locale/pt-br')
window.moment.locale('pt-br')

try {
    window.$ = window.jQuery = require('jquery')
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    })
} catch (e) {}

window.Swal = require('admin-lte/plugins/sweetalert2/sweetalert2.min')

window.axios = require('axios')
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.spinner = {
    show : function () {
        document.querySelector('.preloader').classList.remove('hide')
    },
    hide : function () {
        document.querySelector('.preloader').classList.add('hide')
    }
}
